import { createSlice } from "@reduxjs/toolkit";

const ESTORES_STORAGE_KEY = "estores";

const getInitialEstores = () => {
  try {
    const savedEstores = localStorage.getItem(ESTORES_STORAGE_KEY);
    if (!savedEstores) return [];

    const parsedEstores = JSON.parse(savedEstores);
    return Array.isArray(parsedEstores) ? parsedEstores : [];
  } catch (error) {
    return [];
  }
};

const persistEstores = (estores) => {
  try {
    localStorage.setItem(ESTORES_STORAGE_KEY, JSON.stringify(estores));
  } catch (error) {
    // Ignore write errors to avoid breaking reducer flow.
  }
};

export const estoresSlice = createSlice({
  name: "estores",
  initialState: getInitialEstores(),
  reducers: {
    appendEstore: (state, action) => {
      const existingIndex = state.findIndex(
        (item) => item.estoreId === action.payload.estoreId,
      );

      if (existingIndex === -1) {
        state.push(action.payload);
      } else {
        state[existingIndex] = action.payload;
      }

      persistEstores(state);
    },
    removeEstore: (state, action) => {
      const nextState = state.filter(
        (item) => item.estoreId !== action.payload,
      );
      persistEstores(nextState);
      return nextState;
    },
  },
});

export const { appendEstore, removeEstore } = estoresSlice.actions;

export default estoresSlice.reducer;
